import React, { useState } from 'react'
import { Star, Undo2 } from 'lucide-react'

const defaultScoreLabels: Record<number, string> = {
  1: 'Insuficiente',
  2: 'Abaixo do esperado',
  3: 'Dentro do esperado',
  4: 'Acima do esperado',
  5: 'Excepcional'
}

export interface CompactScoreInputProps {
  value: number
  skipped?: boolean
  onChange: (score: number) => void
  onSkip: () => void
  onUnskip: () => void
  disabled: boolean
  scoreLabels?: Array<{ value: number; label: string; labelPt: string }>
}

export const CompactScoreInput: React.FC<CompactScoreInputProps> = ({
  value, skipped = false, onChange, onSkip, onUnskip, disabled, scoreLabels
}) => {
  const [hoverValue, setHoverValue] = useState(0)

  const getLabel = (scoreValue: number): string => {
    if (scoreLabels?.length) {
      const labelObj = scoreLabels.find(sl => sl.value === scoreValue)
      return labelObj?.labelPt || labelObj?.label || ''
    }
    return defaultScoreLabels[scoreValue] || ''
  }

  if (skipped) {
    return (
      <div className="flex items-center gap-3">
        <span className="text-sm text-brand-gray italic">Não se aplica</span>
        {!disabled && (
          <button
            type="button"
            onClick={onUnskip}
            className="text-xs text-brand-primary hover:text-brand-primary/80 underline"
          >
            <Undo2 className="w-3 h-3 inline mr-1" />Desfazer
          </button>
        )}
      </div>
    )
  }

  return (
    <div className="flex items-center gap-3">
      <div className="flex gap-1">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => onChange(star)}
            onMouseEnter={() => setHoverValue(star)}
            onMouseLeave={() => setHoverValue(0)}
            disabled={disabled}
            className={`w-8 h-8 rounded-md flex items-center justify-center transition-all ${
              star <= (hoverValue || value)
                ? 'text-brand-primary bg-brand-primary/10'
                : 'text-brand-gray bg-brand-dark-lighter'
            } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:scale-110'}`}
          >
            <Star className={`w-5 h-5 ${star <= value ? 'fill-current' : ''}`} />
          </button>
        ))}
      </div>
      <span className={`text-xs min-w-[90px] ${
        value > 0 && value <= 2 ? 'text-warning' : 'text-brand-gray'
      }`}>
        {(hoverValue || value) > 0 ? getLabel(hoverValue || value) : ''}
      </span>
      <button
        type="button"
        onClick={onSkip}
        disabled={disabled}
        className="px-2.5 py-1 rounded-md border border-brand-gray/20 text-xs font-semibold text-brand-gray
          hover:bg-brand-gray/10 hover:border-brand-gray/40 disabled:cursor-not-allowed disabled:opacity-50 transition-all"
      >
        N/A
      </button>
    </div>
  )
}
